import { makeStyles } from '@fluentui/react-components';
import { tokens, useFluentTokens } from '../../../../../theme/fluent';

export const widgetCommonStyles = makeStyles({
  card: {
    display: 'flex',
    flexDirection: 'column',
    borderRadius: tokens.borderRadiusXXXXLarge,
    padding: tokens.spacingVerticalL,
    height: '474px',
  },
});

export const useWidgetCommonStyles = () => {
  const commonClasses = widgetCommonStyles();
  const { modeTokens } = useFluentTokens();
  const cardStyle: React.CSSProperties = {
    backgroundColor: modeTokens.colorNeutralBackground1,
    border: `1px solid ${modeTokens.colorNeutralStroke2}`,
  };
  return { commonClasses, cardStyle };
};
